<p-toast></p-toast>

<div class="container" *ngIf="searched && data && data.length > 0; else noResultsFound">
  <div class="styled-text-wrapper">
    <span class="styled-text">{{ searchQueryGrid }}</span>
  </div>

  <div class="main-content" *ngFor="let item of data; let i = index">
    <div class="card" [ngClass]="{ expanded: expandedCards[i], collapsed: !expandedCards[i] }">
      <div *ngIf="i % 1 === 0" class="route-label-container">
        <div class="line"></div>
        <div class="route-label">
          Patent
          {{
          currentPage_imp === 1
          ? i + 1
          : (currentPage_imp - 1) * (currentRow_imp || 15) + i + 1
          }}
        </div>

        <div class="line"></div>
      </div>
      <section class="product-info" id="productinfo">
        <h4 style="
            font-weight: 800;
            font-size: 20px;
            color: #388e3c;
            margin-bottom: 50px;
            text-align: left;
            background: #0032a0;
            -webkit-background-clip: text;
            color: transparent;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
              -2px -2px 5px rgba(0, 0, 0, 0.1);
            letter-spacing: 1px;
            transition: color 0.3s ease, text-shadow 0.3s ease;
          ">
          {{ item.title || "-" }}
          <button class="copy-btn" *ngIf="item.title" (click)="copyToClipboard(item.title)" pTooltip="Copy to clipboard"
            tooltipPosition="top">
            <i class="pi pi-copy"></i>
          </button>
        </h4>
        <!-- Chemical Structure Image -->
        <!-- <div class="product-container2">
          Left Side: Chemical Structure
          <div class="chemical-structure2" *ngIf="item.routeOfSynthesis">
            <h2>Chemical Structure</h2>
            <div class="image-container2">
              <img
                class="inventor-logo"
                *ngIf="item.routeOfSynthesis"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/route_of_synthesis/' +
                  item.routeOfSynthesis
                "
                alt="Inventor Logo"
              />
            </div>
            <button class="view-btn2" (click)="openGalleria(item)">
              <i class="pi pi-search"></i>
            </button>
          </div>

          Right Side: Product Information
          <div class="product-info-container2">
            <div class="product-info2" *ngIf="item.gbrn">
              <h6>
                GBRN
                <button
                  class="copy-btn2"
                  (click)="copyToClipboardFormattedDate(item.gbrn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              {{ item.gbrn }}
            </div>
            <div class="product-info2" *ngIf="item.trrn">
              <h6>
                TRRN
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.trrn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.trrn || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.activeIngredient">
              <h6>
                ACTIVE INGREDIENT
                <button
                  class="copy-btn2"
                  *ngIf="item.activeIngredient"
                  (click)="copyToClipboard(item.activeIngredient)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.activeIngredient || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.activeIngredientCasRn">
              <h6>
                CAS RN
                <button
                  class="copy-btn2"
                  *ngIf="item.activeIngredientCasRn"
                  (click)="copyToClipboard(item.activeIngredientCasRn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.activeIngredientCasRn || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.fieldOfApplication">
              <h6>
                FIELD OF APPLICATION
                <button
                  class="copy-btn2"
                  *ngIf="item.fieldOfApplication"
                  (click)="copyToClipboard(item.fieldOfApplication)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.fieldOfApplication || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.companyName">
              <h6>
                COMPANY NAME
                <button
                  class="copy-btn2"
                  *ngIf="item.companyName"
                  (click)="copyToClipboard(item.companyName)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>{{ item.companyName || "-" }}</p>
              <div class="logos-images">
                <img
                  style="width: 100px"
                  *ngIf="item.companyLogo; else placeholder"
                  [src]="
                    'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                    item.companyLogo
                  "
                  alt="Inventor Logo"
                  class="inventor-logo"
                  (error)="onImageError($event)"
                />
                <ng-template #placeholder>
                  <span style="width: 300px; display: inline-block"
                    >INVENTOR LOGO</span
                  >
                </ng-template>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Bootstrap Modal for Full Image View -->
        <p-galleria [value]="galleriaImages" [(visible)]="displayGalleria" [containerStyle]="{ 'max-width': '100%' }"
          [numVisible]="1" [circular]="true" [fullScreen]="true" [showItemNavigators]="false" [showThumbnails]="false">
          <ng-template pTemplate="item" let-item>
            <!-- Modal Background (Click to Close) -->
            <div class="modal-overlay" (click)="closeGalleria($event)">
              <div class="image-wrapper" (click)="$event.stopPropagation()">
                <!-- Zoom Controls Positioned at the Top Right -->
                <div class="zoom-controls">
                  <button (click)="zoomIn($event)" title="Zoom In">
                    <i class="pi pi-search-plus"></i>
                  </button>
                  <button (click)="zoomOut($event)" title="Zoom Out">
                    <i class="pi pi-search-minus"></i>
                  </button>
                  <button class="close-button" (click)="closeGalleria($event)">
                    ×
                  </button>
                </div>

                <!-- Scrollable Image Container -->
                <div class="zoom-container">
                  <img [src]="item.itemImageSrc" [style.transform]="'scale(' + zoomLevel + ')'"
                    class="zoomable-image" />
                </div>
              </div>
            </div>
          </ng-template>
        </p-galleria>

        <div class="logos" id="contentToExport3">
          <!-- <h3 class="logos-title">Innovators' Logos</h3> -->
          <!-- Title remains above images -->
          <!-- inventorLogo -->

          <!-- <div class="result-header">
      <h6 style="margin-top: 8px">
        {{ item.companyLogo || "-" }}
      </h6>
    </div> -->
        </div>

        <div class="product-detail" id="contentToExport1">
          <div class="grid grid-cols-3" style="margin-top: -20px">
            <div class="product-info2" *ngIf="displayMap['product'] && item.product">
              <h6>
                PRODUCT
                <button class="copy-btn2" (click)="copyToClipboard(item.product)">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.product || "-" }}</p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['patentPublicationNumber'] &&
                item.patentPublicationNumber
              ">
              <h6>
                Patent Publication Number
                <button class="copy-btn2" (click)="copyToClipboard(item.patentPublicationNumber)">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <ng-container *ngFor="let link of item.patentPublicationNumber.split(';')">
                <p>{{ item.patentPublicationNumber || "-" }}</p>
                <!-- Espacenet Link with E Icon (one line) -->
                <div style="display: flex; align-items: center; margin-bottom: 6px">
                  <a *ngIf="link.trim()" [href]="
                      'https://worldwide.espacenet.com/patent/search/family/' +
                      link.trim() +
                      '/publication/' +
                      link.trim() +
                      'A1?q=' +
                      link.trim()
                    " target="_blank" style="
                      display: flex;
                      align-items: center;
                      text-decoration: none;
                      color: red;
                    ">
                    <span style="
                        background-color: #ffe5e5;
                        color: red;
                        border-radius: 50%;
                        width: 24px;
                        height: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: bold;
                        margin-right: 8px;
                      ">
                      E
                    </span>
                    Espacenet Patent Search
                  </a>
                </div>

                <!-- Google Link with G Icon (separate line) -->
                <div style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 12px;
                  ">
                  <a *ngIf="link.trim()" [href]="
                      'https://patents.google.com/patent/' +
                      link.trim() +
                      '/publication/' +
                      link.trim() +
                      'A1?q=' +
                      link.trim()
                    " target="_blank" style="
                      display: flex;
                      align-items: center;
                      text-decoration: none;
                      color: inherit;
                      color: #0032a0;
                    ">
                    <i class="pi pi-google" style="margin-right: 8px; font-size: 1.2rem"></i>
                    Google Patent Search
                  </a>
                </div>
              </ng-container>
            </div>

            <div class="product-info2" *ngIf="displayMap['applicationNumber'] && item.applicationNumber">
              <h6>
                Application Number

                <button class="copy-btn" *ngIf="item.applicationNumber"
                  (click)="copyToClipboard(item.applicationNumber)" pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.applicationNumber || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['assignee'] && item.assignee">
              <h6>
                Assignee
                <button class="copy-btn" *ngIf="item.assignee" (click)="copyToClipboard(item.assignee)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.assignee || "-" }}
              </p>
            </div>
            <div class="logos-images" *ngIf="displayMap['assigneeLogo'] && item.assigneeLogo">
              <img style="width: 100px" *ngIf="item.assigneeLogo" [src]="
                  'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                  item.assigneeLogo
                " alt="Inventor Logo" class="inventor-logo" (error)="onImageError($event)" />
              <!-- <ng-template #placeholder>
                <span style="width: 300px; display: inline-block"
                  >INVENTOR LOGO</span
                >
              </ng-template> -->
            </div>
            <div class="product-info2" *ngIf="displayMap['gbrn'] && item.gbrn">
              <h6>
                GREEN BOOK REGISTRATION NUMBER (GBRN)

                <button class="copy-btn2" (click)="copyToClipboard(item.gbrn)">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.gbrn || "-" }}</p>
            </div>
            <div class="product-info2" *ngIf="displayMap['publicationDate'] && item.publicationDate">
              <h6>Publication Date</h6>

              {{
              item.publicationDate
              ? (item.publicationDate | date : "yyyy-MM-dd")
              : "-"
              }}
              <button class="copy-btn" *ngIf="item.publicationDate"
                (click)="copyToClipboardFormattedDate(item.publicationDate)" pTooltip="Copy to clipboard"
                tooltipPosition="top">
                <i class="pi pi-copy"></i>
              </button>
            </div>
            <div class="product-info2" *ngIf="displayMap['applicationDate'] && item.applicationDate">
              <h6>Application Date</h6>

              {{
              item.applicationDate
              ? (item.applicationDate | date : "yyyy-MM-dd")
              : "-"
              }}
              <button class="copy-btn" *ngIf="item.applicationDate"
                (click)="copyToClipboardFormattedDate(item.applicationDate)" pTooltip="Copy to clipboard"
                tooltipPosition="top">
                <i class="pi pi-copy"></i>
              </button>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['parentPatentPublicationNumber'] &&
                item.parentPatentPublicationNumber
              ">
              <h6>Parent Patent Publication Number</h6>

              {{ item.parentPatentPublicationNumber || "-" }}

              <button class="copy-btn" *ngIf="item.parentPatentPublicationNumber" (click)="
                  copyToClipboardFormattedDate(
                    item.parentPatentPublicationNumber
                  )
                " pTooltip="Copy to clipboard" tooltipPosition="top">
                <i class="pi pi-copy"></i>
              </button>
            </div>

            <div class="product-info2" *ngIf="displayMap['estimatedExpiry'] && item.estimatedExpiry">
              <h6>Estimated Expiry</h6>

              {{
              item.estimatedExpiry
              ? (item.estimatedExpiry | date : "yyyy-MM-dd")
              : "-"
              }}
              <button class="copy-btn" *ngIf="item.estimatedExpiry"
                (click)="copyToClipboardFormattedDate(item.estimatedExpiry)" pTooltip="Copy to clipboard"
                tooltipPosition="top">
                <i class="pi pi-copy"></i>
              </button>
            </div>

            <div class="product-info2" *ngIf="displayMap['patentType'] && item.patentType">
              <h6>
                Patent Type

                <button class="copy-btn2" (click)="copyToClipboard(item.patentType)">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.patentType || "-" }}</p>
            </div>

            <!-- <div class="product-info2" *ngIf="item.patentType">
              <h6>
                PATENT OR NON-PATENT TYPE
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.patentType)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.patentType || "-" }}</p>
            </div> -->

            <div class="product-info2" *ngIf="displayMap['crlnLitigation'] && item.crlnLitigation">
              <h6>
                Crln Litigation
                <button class="copy-btn2" (click)="copyToClipboard(item.crlnLitigation)">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.crlnLitigation || "-" }}</p>
            </div>
            <div class="product-info2" *ngIf="displayMap['cbrnGapd'] && item.cbrnGapd">
              <h6>
                Cbrn Gapd
                <button class="copy-btn" *ngIf="item.cbrnGapd" (click)="copyToClipboard(item.cbrnGapd)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.cbrnGapd || "-" }}
              </p>
            </div>
            <!-- <div class="product-info2" *ngIf="item.uniformResourceLocator">
              <h6>PATENT OR NON-PATENT URL</h6>
              <p>
                <ng-container
                  *ngFor="let link of item.uniformResourceLocator.split(';')"
                >
                  <button
                    *ngIf="link.trim()"
                    class="visit-link-btn"
                    (click)="openLink(link.trim())"
                  >
                    Visit Link
                  </button>
                </ng-container>
              </p>
            </div> -->

            <div class="product-info2" *ngIf="displayMap['cprnQp'] && item.cprnQp">
              <h6>
                Cprn QP
                <button class="copy-btn2" *ngIf="item.cprnQp" (click)="copyToClipboard(item.cprnQp)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.cprnQp || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['patentKindCodes'] && item.patentKindCodes">
              <h6>
                patent kind codes
                <button class="copy-btn2" *ngIf="item.patentKindCodes" (click)="copyToClipboard(item.patentKindCodes)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentKindCodes || "-" }}
              </p>
            </div>
            <!-- <div
            class="product-info"
            *ngIf="item.downloadableDocs && false"
          >
            <h6> DOWNLOADABLE DOCS</h6>
            <p>
              <ng-container
                *ngFor="
                  let link of item.downloadableDocs.split(
                    ';'
                  )
                "
              >
                <a
                  *ngIf="link.trim()"
                  style="
                      background:linear-gradient(145.5deg,#388e3c,#235e5e 99.58%) !important ;
                      transition: all 0.3s ease;
                    "
                  [href]="
                    'https://chemrobotics.com/agropat/pdf/gsda/docs/' + link.trim()
                  "
                  target="_blank"
                >
                  {{ link.trim() }}
                </a>
              </ng-container>
            </p>
          </div> -->

            <div class="product-info2" *ngIf="displayMap['patentFamily'] && item.patentFamily">
              <h6>
                patent family
                <button class="copy-btn2" *ngIf="item.patentFamily" (click)="copyToClipboard(item.patentFamily)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentFamily || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="
                displayMap['indianPatentEquivalents'] &&
                item.indianPatentEquivalents
              ">
              <h6>
                indian patent equivalents
                <button class="copy-btn2" *ngIf="item.indianPatentEquivalents"
                  (click)="copyToClipboard(item.indianPatentEquivalents)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.indianPatentEquivalents || "-" }}
              </p>
            </div>
            <!-- <div class="product-info" *ngIf="item.patentLink">
              <h6>
                PATENT LINK
                <button
                  class="copy-btn"
                  *ngIf="item.patentLink"
                  (click)="copyToClipboard(item.patentLink)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentLink || "-" }}
              </p>
            </div> -->
            <!-- <div
              class="product-info2"
              *ngIf="item.title"
            >
              <h6>
                title
                <button
                  class="copy-btn2"
                  *ngIf="item.title"
                  (click)="
                    copyToClipboard(item.title)
                  "
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.title || "-" }}
              </p>
            </div> -->
            <div class="product-info2" *ngIf="displayMap['inventors'] && item.inventors">
              <h6>
                inventors
                <button class="copy-btn2" *ngIf="item.inventors" (click)="copyToClipboard(item.inventors)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.inventors || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['ipc'] && item.ipc">
              <h6>
                ipc
                <button class="copy-btn2" *ngIf="item.ipc" (click)="copyToClipboard(item.ipc)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.ipc || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['priorityNumbers'] && item.priorityNumbers">
              <h6>
                priority numbers
                <button class="copy-btn2" *ngIf="item.priorityNumbers" (click)="copyToClipboard(item.priorityNumbers)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.priorityNumbers || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['earliest_priorityDate_epd'] &&
                item.earliest_priorityDate_epd
              ">
              <h6>
                earliest priority date epd
                <button class="copy-btn2" *ngIf="item.earliest_priorityDate_epd"
                  (click)="copyToClipboard(item.earliest_priorityDate_epd)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.earliest_priorityDate_epd || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['country'] && item.country">
              <h6>
                country
                <button class="copy-btn2" *ngIf="item.country" (click)="copyToClipboard(item.country)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.country || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['language'] && item.language">
              <h6>
                language
                <button class="copy-btn2" *ngIf="item.language" (click)="copyToClipboard(item.language)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.language || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['patentStatus'] && item.patentStatus">
              <h6>
                patent status
                <button class="copy-btn2" *ngIf="item.patentStatus" (click)="copyToClipboard(item.patentStatus)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentStatus || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['patentFamilyStatus'] && item.patentFamilyStatus
              ">
              <h6>
                patent family status
                <button class="copy-btn2" *ngIf="item.language" (click)="copyToClipboard(item.patentFamilyStatus)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentFamilyStatus || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['patentFamilyLiveDead'] && item.patentFamilyLiveDead
              ">
              <h6>
                patent family live dead
                <button class="copy-btn2" *ngIf="item.patentFamilyLiveDead"
                  (click)="copyToClipboard(item.patentFamilyLiveDead)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentFamilyLiveDead || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['designateStatesDs'] && item.designateStatesDs">
              <h6>
                designate states ds
                <button class="copy-btn2" *ngIf="item.designateStatesDs"
                  (click)="copyToClipboard(item.designateStatesDs)" pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.designateStatesDs || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['keywords'] && item.keywords">
              <h6>
                keywords
                <button class="copy-btn2" *ngIf="item.keywords" (click)="copyToClipboard(item.keywords)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.keywords || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['patentDesignatedStatesDs'] &&
                item.patentDesignatedStatesDs
              ">
              <h6>
                patentDesignatedStatesDs
                <button class="copy-btn2" *ngIf="item.patentDesignatedStatesDs"
                  (click)="copyToClipboard(item.patentDesignatedStatesDs)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentDesignatedStatesDs || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['fieldOfInvention'] && item.fieldOfInvention">
              <h6>
                field of invention
                <button class="copy-btn2" *ngIf="item.fieldOfInvention" (click)="copyToClipboard(item.fieldOfInvention)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.fieldOfInvention || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['technology'] && item.technology">
              <h6>
                technology
                <button class="copy-btn2" *ngIf="item.technology" (click)="copyToClipboard(item.technology)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.technology || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['chemicalClass'] && item.chemicalClass">
              <h6>
                chemical class
                <button class="copy-btn2" *ngIf="item.chemicalClass" (click)="copyToClipboard(item.chemicalClass)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.chemicalClass || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['indication'] && item.indication">
              <h6>
                indication
                <button class="copy-btn2" *ngIf="item.indication" (click)="copyToClipboard(item.indication)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.indication || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['mechanismOfActionMoa'] && item.mechanismOfActionMoa
              ">
              <h6>
                mechanism of action moa
                <button class="copy-btn2" *ngIf="item.language" (click)="copyToClipboard(item.mechanismOfActionMoa)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.mechanismOfActionMoa || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['obSpcPatents'] && item.obSpcPatents">
              <h6>
                ob spc patents
                <button class="copy-btn2" *ngIf="item.obSpcPatents" (click)="copyToClipboard(item.obSpcPatents)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.obSpcPatents || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['litigationOppositionFiled'] &&
                item.litigationOppositionFiled
              ">
              <h6>
                litigation opposition filed
                <button class="copy-btn2" *ngIf="item.litigationOppositionFiled"
                  (click)="copyToClipboard(item.litigationOppositionFiled)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.litigationOppositionFiled || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['legalStatus'] && item.legalStatus">
              <h6>
                legal status
                <button class="copy-btn2" *ngIf="item.legalStatus" (click)="copyToClipboard(item.legalStatus)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.legalStatus || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['genericLaunchGeneralCommentary'] &&
                item.genericLaunchGeneralCommentary
              ">
              <h6>
                generic launch general commentary
                <button class="copy-btn2" *ngIf="item.genericLaunchGeneralCommentary"
                  (click)="copyToClipboard(item.genericLaunchGeneralCommentary)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.genericLaunchGeneralCommentary || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['documents'] && item.documents">
              <h6>
                documents
                <button class="copy-btn2" *ngIf="item.documents" (click)="copyToClipboard(item.documents)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.documents || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['updationDate'] && item.updationDate">
              <h6>
                updation date
                <button class="copy-btn2" *ngIf="item.updationDate" (click)="copyToClipboard(item.updationDate)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.updationDate || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['references'] && item.references">
              <h6>
                references
                <button class="copy-btn2" *ngIf="item.references" (click)="copyToClipboard(item.references)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.references || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['remarks'] && item.remarks">
              <h6>
                remarks
                <button class="copy-btn2" *ngIf="item.remarks" (click)="copyToClipboard(item.remarks)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.remarks || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['notes'] && item.notes">
              <h6>
                notes
                <button class="copy-btn2" *ngIf="item.notes" (click)="copyToClipboard(item.notes)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.notes || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['comments'] && item.comments">
              <h6>
                comments
                <button class="copy-btn2" *ngIf="item.comments" (click)="copyToClipboard(item.comments)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.comments || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['miscellaneous'] && item.miscellaneous">
              <h6>
                miscellaneous
                <button class="copy-btn2" *ngIf="item.miscellaneous" (click)="copyToClipboard(item.miscellaneous)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.miscellaneous || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['dcouments'] && item.dcouments">
              <h6>
                dcouments
                <button class="copy-btn2" *ngIf="item.dcouments" (click)="copyToClipboard(item.dcouments)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.dcouments || "-" }}
              </p>
            </div>
          </div>
        </div>
        <br />

        <!-- Additional Product Details -->
        <div class="product-additional-details">
          <div class="grid grid-cols-2 gap-2" style="margin-top: -15px">
            <div class="product-info" *ngIf="displayMap['patentLink'] && item.patentLink">
              <!-- <h6>GOOGLE PATENT HYPERLINK OF PATENT (PATENT LANDSCAPE)</h6> -->

              <!-- Image Below Heading -->
              <img src="../../../../assets/img/GooglePatents.png" alt="Patent Icon" class="patent-image"
                style="width: 150px; height: 60px" />

              <p>
                <ng-container *ngFor="let link of item.patentLink.split(';')">
                  <a *ngIf="link.trim()" [href]="'https://patents.google.com/patent/' + link.trim()" target="_blank">
                    {{ link.trim() }}
                  </a>
                </ng-container>
              </p>
            </div>

            <div class="product-info" *ngIf="
                displayMap['uniformResourceLocator'] &&
                item.uniformResourceLocator
              ">
              <!-- <h6>ESPACE.NET PATENT HYPERLINK OF PATENT (PATENT LANDSCAPE)</h6> -->
              <img src="../../../../assets/img/espace-logo.png" alt="Patent Icon" class="patent-image"
                style="width: 150px; height: 60px; margin-left: 6px" />
              <p>
                <ng-container *ngFor="let link of item.patentLink.split(';')">
                  <a *ngIf="link.trim()" style="
                      background: #be0f04 !important ;
                      transition: all 0.3s ease;
                    " [href]="
                      'https://worldwide.espacenet.com/patent/search/family/' +
                      link.trim() +
                      '/publication/' +
                      link.trim() +
                      'A1?q=' +
                      link.trim()
                    " target="_blank">
                    {{ link.trim() }}
                  </a>
                </ng-container>
              </p>
            </div>
          </div>

          <!-- <div
            class="section-wrapper"
            id="dataAvailablity"
            *ngIf="dataAvailablity.length > 0"
            let
            i="index1"
          >
            <hr class="section-divider" />
            <h2 class="section-title">Data Availability</h2>

            <a
              *ngFor="let data of dataAvailablity"
              class=""
              [href]="
                'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' +
                data.documents
              "
              target="_blank"
            >
              <button
                class="btn btn-success m-1"
                style="
                  background: linear-gradient(
                    145.5deg,
                    #388e3c,
                    #235e5e 99.58%
                  );
                  color: rgb(255 237 141);
                  gap: 10px;
                "
              >
                {{ data.nameOfDocuments }}
              </button>
            </a>
          </div> -->

          <!-- First Section Wrapper -->
          <div class="section-wrapper" id="description" *ngIf="displayMap['abstract'] && item.abstract">
            <hr class="section-divider" />
            <h2 class="section-title">
              Abstract
              <button class="copy-btn" *ngIf="item.abstract" (click)="copyToClipboard(item.abstract)"
                pTooltip="Copy to clipboard" tooltipPosition="top" style="color: #ffe16a">
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.abstract }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>
          <div class="section-wrapper" id="description" *ngIf="displayMap['claims'] && item.claims">
            <hr class="section-divider" />
            <h2 class="section-title">
              claims
              <button class="copy-btn" *ngIf="item.claims" (click)="copyToClipboard(item.claims)"
                pTooltip="Copy to clipboard" tooltipPosition="top" style="color: #ffe16a">
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.claims }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>

          <div class="section-wrapper" id="description" *ngIf="displayMap['description'] && item.description">
            <hr class="section-divider" />
            <h2 class="section-title">
              description:
              <button class="copy-btn" *ngIf="item.description" (click)="copyToClipboard(item.description)"
                pTooltip="Copy to clipboard" tooltipPosition="top" style="color: #ffe16a">
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.description }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>

          <div *ngIf="
              item.dummy1 ||
              item.dummy2 ||
              item.dummy3 ||
              item.dummy4 ||
              item.dummy5 ||
              item.dummy6 ||
              item.dummy7 ||
              item.dummy8 ||
              item.dummy9 ||
              item.dummy10 ||
              item.dummy11 ||
              item.dummy12 ||
              item.dummy13 ||
              item.dummy14
            " class="section-wrapper" id="dummy">
            <hr class="section-divider" />
            <h2 class="section-title">DUMMY</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-2">
                <div *ngIf="displayMap['dummy1'] && item.dummy1" class="product-info">
                  <h6>
                    DUMMY 1
                    <button class="copy-btn" *ngIf="item.dummy1" (click)="copyToClipboard(item.dummy1)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy1 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy1 || '-')"></p> -->
                </div>

                <div *ngIf="displayMap['dummy2'] && item.dummy2" class="product-info">
                  <h6>
                    DUMMY 2
                    <button class="copy-btn" *ngIf="item.dummy2" (click)="copyToClipboard(item.dummy2)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy2 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy2 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy3'] && item.dummy3" class="product-info">
                  <h6>
                    DUMMY 3
                    <button class="copy-btn" *ngIf="item.dummy3" (click)="copyToClipboard(item.dummy3)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy3 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy3 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy4'] && item.dummy4" class="product-info">
                  <h6>
                    DUMMY 4
                    <button class="copy-btn" *ngIf="item.dummy4" (click)="copyToClipboard(item.dummy4)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy4 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy4 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy5'] && item.dummy5" class="product-info">
                  <h6>
                    DUMMY 5
                    <button class="copy-btn" *ngIf="item.dummy5" (click)="copyToClipboard(item.dummy5)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy5 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy5 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy6'] && item.dummy6" class="product-info">
                  <h6>
                    DUMMY 6
                    <button class="copy-btn" *ngIf="item.dummy6" (click)="copyToClipboard(item.dummy6)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy6 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy6 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy7'] && item.dummy7" class="product-info">
                  <h6>
                    DUMMY 7
                    <button class="copy-btn" *ngIf="item.dummy7" (click)="copyToClipboard(item.dummy7)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy7 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy7 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy8'] && item.dummy8" class="product-info">
                  <h6>
                    DUMMY 8
                    <button class="copy-btn" *ngIf="item.dummy1" (click)="copyToClipboard(item.dummy1)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy8 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy8 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy9'] && item.dummy9" class="product-info">
                  <h6>
                    DUMMY 9
                    <button class="copy-btn" *ngIf="item.dummy9" (click)="copyToClipboard(item.dummy9)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy9 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy9 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy10'] && item.dummy10" class="product-info">
                  <h6>
                    DUMMY 10
                    <button class="copy-btn" *ngIf="item.dummy10" (click)="copyToClipboard(item.dummy10)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy10 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy10 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy11'] && item.dummy11" class="product-info">
                  <h6>
                    DUMMY 11
                    <button class="copy-btn" *ngIf="item.dummy11" (click)="copyToClipboard(item.dummy11)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy11 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy11 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy12'] && item.dummy12" class="product-info">
                  <h6>
                    DUMMY 12
                    <button class="copy-btn" *ngIf="item.dummy12" (click)="copyToClipboard(item.dummy12)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy12 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy12 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy13'] && item.dummy13" class="product-info">
                  <h6>
                    DUMMY 13
                    <button class="copy-btn" *ngIf="item.dummy13" (click)="copyToClipboard(item.dummy13)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy13 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy13 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy14'] && item.dummy14" class="product-info">
                  <h6>
                    DUMMY 14
                    <button class="copy-btn" *ngIf="item.dummy14" (click)="copyToClipboard(item.dummy14)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy14 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy14 || '-')"></p> -->
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>
        </div>
      </section>
      <button class="read-more-btn" *ngIf="hasExpandableContent(item)" (click)="toggleCard(i)">
        {{ expandedCards[i] ? "Read Less" : "Read More" }}
      </button>
    </div>

    <!-- Sidebar -->
    <aside class="sidebar" *ngIf="i == 0">
      <div style="
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
        ">
        <!-- Left side: Total Records -->
        <div style="width: 50%">
          <strong style="
              background: #0032a0;
              color: #ffed8d;
              font-size: 16px;
              font-weight: 700;
              padding: 11px 15px;
              border-radius: 12px;
              box-shadow: 0 2px 4px #0003;
              white-space: nowrap;
              display: block;
              width: fit-content;
            ">
            Total Records: {{ totalRecords }}
          </strong>
        </div>

        <!-- Right side: Buttons -->
        <div style="
            width: 50%;
            display: flex;
            justify-content: flex-end;
            margin-left: 50px;
          ">
          <button style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              margin-right: 10px;
            " (click)="exportExcel('csv')">
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">CSV</span>
          </button>
          <button style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
            " (click)="exportExcel('xlsx')">
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">XLS</span>
          </button>
        </div>
      </div>

      <h3 class="sidebar-title">
        Filters
        <button class="sidebar-toggle" (click)="toggleSidebar()">
          <span *ngIf="!isSidebarOpen">☰</span>
          <span *ngIf="isSidebarOpen">×</span>
        </button>
      </h3>

      <ul [class.active]="isSidebarOpen">
        <li>
          <label for="categoryFilter">PRODUCT</label>
          <p-dropdown [options]="productOptions" [filter]="true" filterPlaceholder="Search Product Type"
            class="w-full custom-dropdown" [(ngModel)]="currentFliter.product"
            (onChange)="createFilter('product', $event.value)" placeholder="Select Product Type"></p-dropdown>
        </li>

        <li>
          <label for="categoryFilter">PATENT TYPE</label>
          <p-dropdown [options]="patentTypeOptions" [filter]="true" filterPlaceholder="Search Patent Type "
            class="w-full custom-dropdown" [(ngModel)]="currentFliter.patentType"
            (onChange)="createFilter('patentType', $event.value)" placeholder="Select Patent Type "></p-dropdown>
        </li>

        <li>
          <label for="categoryFilter">ASSIGNEE</label>
          <p-dropdown [options]="assigneeOptions" [filter]="true" filterPlaceholder="Search Assignee"
            class="w-full custom-dropdown" [(ngModel)]="currentFliter.assignee"
            (onChange)="createFilter('assignee', $event.value)" placeholder="Select Assignee"></p-dropdown>
        </li>

        <!-- <li>
          <label for="categoryFilter">APPLICATION OF INTER</label>
          <p-dropdown
            [options]="PlatformFliters.activeIngredient"
            [filter]="true"
            filterPlaceholder="Search Application Of Inter"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.activeIngredient"
            (onChange)="createFilter('activeIngredient', $event.value)"
            placeholder="Select Application Of Inter"
          ></p-dropdown>
        </li> -->

        <!-- <li>
          <label for="categoryFilter">FEILD OF APPLICATION</label>
          <p-dropdown
            [options]="PlatformFliters.fieldOfApplication"
            [filter]="true"
            filterPlaceholder="Search Feild Of Application"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.fieldOfApplication"
            (onChange)="createFilter('fieldOfApplication', $event.value)"
            placeholder="Select Feild Of Application"
          ></p-dropdown>
        </li> -->

        <li>
          <label for="colorFilter">ORDER</label>

          <p-dropdown [options]="sortByOptions" [filter]="true" filterPlaceholder="Search Order" filterBy="name"
            class="w-full custom-dropdown" [(ngModel)]="sortBy" (onChange)="applyFilter()" optionLabel="name"
            optionValue="code" placeholder="Select Order">
          </p-dropdown>
        </li>
        <!-- <li>
          <label for="categoryFilter">UPDATION DATE</label>
          <p-dropdown
            [options]="PlatformFliters.updationDate"
            [filter]="true"
            filterPlaceholder="Search Updation Date"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.updationDate"
            (onChange)="createFilter('updationDate', $event.value)"
            placeholder="Select Updation Date"
          ></p-dropdown>
        </li> -->
      </ul>
      <div class="filter-buttons">
        <button (click)="applyFilter()">Apply Filter</button>
        <button (click)="resetFilter()">Reset Filter</button>
      </div>
    </aside>
  </div>

  <div class="pagination-container">
    <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
      [styleClass]="'custom-paginator'">
    </p-paginator>

    <p class="total-pages" *ngIf="totalpages > 2">
      Total Pages: <span>{{ totalpages }}</span>
    </p>
  </div>
  <button class="back_to_top my-5" (click)="scrollToTop()">
    <img class="back_to_top_img" src="../../../assets/icons/output-onlinepngtools (5).png" />
  </button>
</div>
<ng-template #noResultsFound>
  <div class="no-results-container" *ngIf="searched">
    <img src="../../../assets/img/no-data.png" class="no-results-image" alt="No data available" />
    <div class="no-results-message color_black">
      <span class="font_20 weight_800">Sorry – The search found zero results. Why…</span>
      <ul class="no-results-list text_start">
        <li>
          <span class="font_20 weight_500">Make sure you have selected the correct search criteria</span>
        </li>
        <li>
          <span class="font_20 weight_500">Make sure that all words are spelled correctly</span>
        </li>
        <li>
          <span class="font_20 weight_500">Try different keywords</span>
        </li>
        <li>
          <span class="font_20 weight_500">Try more general keywords</span>
        </li>
      </ul>
    </div>
    <!-- Back to search button -->
    <button class="btn-back-to-search" (click)="goBackToSearch()">
      Back to Search
    </button>
  </div>
</ng-template>